module.exports = __webpack_public_path__ + "img/SSKAtworks.f9dd09a3.png";